/**
 * 页面缓存工具
 * 用于管理页面缓存和定时刷新
 */

/**
 * 设置页面缓存刷新监听
 * @param {Function} refreshCallback 刷新回调函数
 * @param {Object} options 配置选项
 * @param {number} options.refreshInterval 刷新间隔（毫秒），默认2分钟
 * @param {boolean} options.autoRefreshOnActivated 激活时自动刷新，默认true
 * @returns {Function} 清理函数，用于在组件卸载时调用
 */
export function setupPageCacheRefresh(refreshCallback, options = {}) {
  // 解构选项（虽然当前未使用，但保留用于未来扩展）
  /* eslint-disable no-unused-vars */
  const {
    refreshInterval = 120000, // 默认2分钟
    autoRefreshOnActivated = true // 默认true
  } = options
  /* eslint-enable no-unused-vars */

  // 缓存刷新处理函数
  const handleCacheRefresh = () => {
    // 如果当前页面可见，则刷新数据
    if (document.visibilityState === 'visible') {
      console.log('缓存刷新：触发页面数据刷新')
      refreshCallback()
    }
  }

  // 监听全局缓存刷新事件
  window.addEventListener('page-cache-refresh', handleCacheRefresh)

  // 返回清理函数
  return () => {
    window.removeEventListener('page-cache-refresh', handleCacheRefresh)
  }
}

/**
 * 获取页面刷新时间戳
 * @param {string} pageKey 页面唯一标识
 * @returns {number|null} 时间戳，如果不存在则返回null
 */
export function getPageRefreshTime(pageKey) {
  const timeStr = localStorage.getItem(`${pageKey}-refresh-time`)
  return timeStr ? parseInt(timeStr) : null
}

/**
 * 设置页面刷新时间戳
 * @param {string} pageKey 页面唯一标识
 */
export function setPageRefreshTime(pageKey) {
  localStorage.setItem(`${pageKey}-refresh-time`, Date.now().toString())
}

/**
 * 检查页面数据是否需要刷新
 * @param {string} pageKey 页面唯一标识
 * @param {number} maxAge 最大缓存时间（毫秒），默认2分钟
 * @returns {boolean} 是否需要刷新
 */
export function shouldRefreshPage(pageKey, maxAge = 120000) {
  const lastRefreshTime = getPageRefreshTime(pageKey)
  if (!lastRefreshTime) {
    return true
  }
  const timeDiff = Date.now() - lastRefreshTime
  return timeDiff > maxAge
}

